<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions style="float: right; margin-top: 5px;">
  <button mat-raised-button  (click)="close(false)">{{data.decline || 'Close'}}</button>
  <button mat-raised-button color="primary" cdkFocusInitial (click)="close(true)">{{data.accept || 'Yes'}}</button>  
</mat-dialog-actions>